import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/activeClientsSagas";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const CustomDateRanges = () => {
  const dispatch = useDispatch();
  const rangeOptions = useSelector((state) => state.activeClients.rangeOptions);
  const selectedRangeOption = useSelector((state) => state.activeClients.selectedRangeOption);

  return (
    <MultiSelectDropdown
      options={rangeOptions}
      includeFilter={false}
      numberDisplayed={0}
      selectedFilters={selectedRangeOption}
      onSelectChange={(data) => dispatch(actionCreators.updateCustomRange(data))}
    />
  );
};

export default CustomDateRanges;
